export enum AbschlussKategorie {
  schule = 'schule',
  lehre = 'lehre',
  studium = 'studium'
}

export interface Schule {
  typ: AbschlussKategorie.schule;
  name: string;
  abschluss: string | null;
  abschlussTyp: string | null;
  ende: Date | null;
}

export interface Studium {
  typ: AbschlussKategorie.studium;
  hochschule: string;
  fachrichtung: string | null;
  abschluss: string | null;
  andererAbschluss: string | null;
  abschlussTyp: string | null;
  von: Date;
  bis: Date | null;
}

export interface Lehre {
  typ: AbschlussKategorie.lehre;
  unternehmen: string;
  branche: string | null;
  abschluss: string | null;
  abschlussTyp: string;
  von: Date;
  bis: Date | null;
}

export type Ausbildung = Schule | Studium | Lehre;

export interface Berufserfahrung {
  positionsbezeichnung: string;
  beschaeftigungsart: string;
  unternehmen: string | null;
  url: string | null;
  branche: string;
  von: Date;
  bis: Date | null;
}

export interface Ehrenamt {
  institution: string;
  taetigkeit: string | null;
  von: Date;
  bis: Date | null;
}

export interface Bild {
  src: string;
  grayscale: boolean;
}

export interface BewerbungUnterlagen {
  bild: Bild | null;
  berufserfahrung: Berufserfahrung[];
  ausbildung: Ausbildung[];
  ehrenamt: Ehrenamt[];
  sonstiges: string | null;
  motivation: string;
}
